import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const bundleItems = [{
  title: 'Libro "El reinicio biológico"',
  desc: 'El protocolo técnico de 14 días.',
  value: '97€',
  img: 'https://cdn.magicpatterns.com/uploads/guBBjP7nB5xnsFAJKdRdie/LIBRO_EL_REINICIO_BIOLOGICO_2B_BONOS.png',
  isMain: true
}, {
  title: 'BONO 1 - Hoja de Ruta',
  desc: 'Tu guía paso a paso. Cero dudas.',
  value: '27€',
  img: 'https://cdn.magicpatterns.com/uploads/4GT6i9N1MMgaUpbWtT4Q4T/BONO_1.webp',
  isMain: false
}, {
  title: 'BONO 2 - Recetario Express',
  desc: 'Comidas de 10 min. que NO inflaman.',
  value: '47€',
  img: 'https://cdn.magicpatterns.com/uploads/5bSBCaftJ1Nd1PwCGojysp/BONO_2.webp',
  isMain: false
}, {
  title: 'BONO 3 - Guía de Saboteadores',
  desc: 'Detecta los venenos del súper.',
  value: '17€',
  img: 'https://cdn.magicpatterns.com/uploads/eTVB4gPn3pR4RmcyzXeygA/BONO_3.webp',
  isMain: false
}, {
  title: 'BONO 4 - Lista de Compras',
  desc: 'Inventario exacto para el éxito.',
  value: '17€',
  img: 'https://cdn.magicpatterns.com/uploads/rTVDsy81HqVWcUQ4smjK5t/BONO_4.webp',
  isMain: false
}];
export function BundleSection() {
  return <section className="bg-warm-white py-12 md:py-20 px-4" data-id="element-9">
      <div className="max-w-5xl mx-auto" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-14" data-id="element-11">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-emerald-deep mb-4" data-id="element-12">
            Todo lo que incluye tu acceso hoy:
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-13"></div>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mb-10 md:mb-14" data-id="element-14">
          {bundleItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-white rounded-2xl p-5 md:p-6 shadow-lg border border-warm-gray flex relative overflow-hidden ${item.isMain ? 'flex-col sm:col-span-2 md:flex-row items-center text-center md:text-left md:p-10 bg-gradient-to-br from-white to-warm-gray/30' : 'flex-col md:flex-row items-center md:items-start text-center md:text-left'}`} data-id="element-15">
              {/* Subtle ribbon for bonuses */}
              {!item.isMain && <div className="absolute top-0 left-0 w-full h-1.5 bg-emerald-light/40" data-id="element-16"></div>}

              <div className={`${item.isMain ? 'w-full md:w-1/2 mb-6 md:mb-0 md:pr-10' : 'w-full md:w-2/5 mb-4 md:mb-0 md:pr-4 flex justify-center'}`} data-id="element-17">
                <img src={item.img} alt={item.title} className={`object-contain ${item.isMain ? 'h-48 md:h-64 mx-auto' : 'h-32 md:h-28'}`} data-id="element-18" />
              </div>

              <div className={`${item.isMain ? 'w-full md:w-1/2' : 'w-full md:w-3/5 flex flex-col justify-center h-full'}`} data-id="element-19">
                <h3 className={`${item.isMain ? 'text-2xl md:text-3xl' : 'text-xl'} font-display font-bold text-emerald-deep mb-2`} data-id="element-20">
                  {item.title}
                </h3>
                <p className="text-gray-600 font-body mb-4 text-sm md:text-base" data-id="element-21">
                  {item.desc}
                </p>
                <div className="mt-auto" data-id="element-22">
                  <div className="inline-block bg-emerald-light/10 text-emerald-dark font-bold px-4 py-1.5 rounded-full text-sm border border-emerald-light/20" data-id="element-23">
                    Valor: {item.value}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-emerald-deep text-white rounded-3xl p-6 md:p-12 text-center max-w-3xl mx-auto shadow-2xl relative overflow-hidden" data-id="element-24">
          <div className="absolute top-0 left-0 w-full h-full dna-pattern opacity-30" data-id="element-25"></div>
          <div className="relative z-10" data-id="element-26">
            <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-8" data-id="element-27">
              <div className="text-center" data-id="element-28">
                <p className="text-warm-white/70 text-sm uppercase tracking-wider mb-1" data-id="element-29">
                  Valor Total
                </p>
                <p className="text-3xl font-display text-gray-400 price-strike" data-id="element-30">
                  205€
                </p>
              </div>
              <div className="hidden md:block w-px h-12 bg-white/20" data-id="element-31"></div>
              <div className="text-center" data-id="element-32">
                <p className="text-gold text-sm uppercase tracking-wider mb-1 font-bold" data-id="element-33">
                  Precio Hoy
                </p>
                <p className="text-5xl font-display font-bold text-gold-bright" data-id="element-34">
                  26€{' '}
                  <span className="text-lg text-warm-white/70 normal-case font-body" data-id="element-35">
                    (IVA Incluido)
                  </span>
                </p>
              </div>
            </div>

            <CTAButton text="👉 SÍ, QUIERO MI REINICIO — 26€" data-id="element-36" />
          </div>
        </motion.div>
      </div>
    </section>;
}